import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { loadInStoreOrderForm } from './actions'
import { loadInStoreVendor } from '../vendor/actions'
import Loader from '@/checkout-instore-legacy/components/Commons/Loader'

const withOrderFormAndVendor = (Component) => {
  class WithOrderFormAndVendor extends PureComponent {
    componentDidMount() {
      const { vendor, orderForm } = this.props
      if (!orderForm) {
        if (!vendor) {
          this.props.loadInStoreVendorCustom()
        } else {
          this.props.loadInStoreOrderFormCustom(vendor)
        }
      }
    }

    componentDidUpdate() {
      const { vendor, orderForm, loadingOrderForm } = this.props
      if (!orderForm && !loadingOrderForm) {
        if (!vendor) {
          this.props.loadInStoreVendorCustom()
        } else {
          this.props.loadInStoreOrderFormCustom(vendor)
        }
      }
    }

    render() {
      const customProps = {
        ...this.props,
      }
      delete customProps.loadInStoreOrderFormCustom
      delete customProps.loadingOrderForm
      delete customProps.loadInStoreVendorCustom
      return !this.props.orderForm || !this.props.vendor ? (
        <Loader loading />
      ) : (
        <Component
          {...customProps}
          orderForm={this.props.orderForm}
          vendor={this.props.vendor}
        />
      )
    }
  }

  WithOrderFormAndVendor.propTypes = {
    orderForm: PropTypes.object,
    vendor: PropTypes.object,
    loadingOrderForm: PropTypes.bool,
    loadInStoreOrderFormCustom: PropTypes.func.isRequired,
    loadInStoreVendorCustom: PropTypes.func.isRequired,
  }

  const mapStateToProps = (state) => ({
    orderForm: state.order.orderForm,
    loadingOrderForm: state.order.loading,
    vendor: state.vendor.vendor,
  })

  const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
      {
        loadInStoreOrderFormCustom: loadInStoreOrderForm,
        loadInStoreVendorCustom: loadInStoreVendor,
      },
      dispatch
    )

  return connect(mapStateToProps, mapDispatchToProps)(WithOrderFormAndVendor)
}

export default withOrderFormAndVendor
